import React from 'react';
import classNames from 'classnames';
import { AlertCircle } from 'lucide-react';
import { cn } from 'lib/utils';
import { Button } from 'components/ui/button';
import { useNavigate, useLocation } from 'react-router-dom';
import routeConfig from 'routes/config';

const NoAccessToStore = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const storeName = state?.storeName;
  const ownerEmail = state?.ownerEmail;

  if (!storeName) {
    navigate(`/${routeConfig.STORES.layout}/${routeConfig.STORES.LIST.path}`);
    return <></>;
  }

  return (
    <div className="mt-9" style={{ width: '512px' }}>
      <h1 className="mb-5 text-2xl font-semibold leading-8 text-gray-blue-90">
        Stores
      </h1>
      <div
        className={cn(
          'mb-10 flex min-h-13 items-start rounded-sm border border-yellow-550 bg-yellow-100 p-4 text-sm font-normal text-gray-blue-70',
          'mb-8'
        )}
      >
        <AlertCircle className="mr-10" size={32} />
        <span>
          You do not have access to{' '}
          <span
            className={classNames({
              'font-bold text-gray-blue-70': state?.storeName,
            })}
          >
            {storeName || 'this'}
          </span>{' '}
          store on TreezPay.
        </span>
      </div>
      <div className="body-subtext-regular mb-8 text-gray-blue-70">
        Please contact{' '}
        <span className={classNames({ 'font-semibold': state?.ownerEmail })}>
          {ownerEmail}
        </span>{' '}
        to get access to the store.
      </div>
      <Button
        variant="treez-green"
        size="full"
        rounded="base"
        onClick={() => {
          navigate(
            `/${routeConfig.STORES.layout}/${routeConfig.STORES.LIST.path}`
          );
        }}
        type="button"
      >
        Go back
      </Button>
    </div>
  );
};

export default NoAccessToStore;
